import React from 'react';
import { BaseProps } from 'src/common/container';

type Props = BaseProps & {
  src: string;
  alt: string;
};

export const Image = ({ src, ...rest }: Props) => {
  // @ts-ignore FOR NOW TODO: fix
  return <img src={src} {...rest} />;
};
